export default __webpack_public_path__ + "static/media/imageMain.bcf067f1.png";